import store from "store";
import router from "@/router-editor";
import debounce from "lodash/debounce";
import find from "lodash/find";
import map from "lodash/map";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import { db } from "@/firestore";
import firebase from "firebase/app";
import axios from "axios";
import * as Bowser from "bowser";
import "firebase/firestore";
import { returnAllRubberBandArray } from "@/store/utils/rubberBands";

const saveToServerDelay_ms = 1000;
const saveToHistoryDelay_ms = 500;

const updateCurrentShow = (getters, state, commit, dispatch) => {
  // All actual data saving happens here.
  console.log("updateCurrentShow");
  console.log(state.currentShowDetails.data);
  if (state.disableSaving) {
    console.warn("Saving disabled!");
    return;
  }
  var updated_at = new Date().getTime();
  // Update on server.
  var update = {
    data: state.currentShowDetails.data,
    updated_at: updated_at,
  };
  db.collection("editor_shows")
    .doc(state.currentShowId)
    .update(update)
    .then(function() {
      console.log("updateCurrentShow", "success");
      dispatch("showsJson/publishJson", state.currentShowDetails, {
        root: true,
      });
    });
  commit("saveCompleted");
};

const updateCurrentShowHistory = (state, commit) => {
  // All actual data saving happens here.
  console.log("updateCurrentShowHistory");
  // Update local history.
  if (!state.historyAction) {
    commit("addHistory");
    // Legit history save, empty out the redo.
    state.historyUndoLevel = 0;
  } else {
    state.historyAction = false;
  }
};

const debouncedSaveToServer = debounce(updateCurrentShow, saveToServerDelay_ms);
const debouncedSaveToHistory = debounce(
  updateCurrentShowHistory,
  saveToHistoryDelay_ms
);

export default {
  clearAll() {
    store.clearAll();
  },
  viewActiveShow({ state }) {
    // Open in a new window for now.
    var previewUrl = router.resolve({
      name: "preview-only-exact",
      params: {
        id: state.currentShowId,
      },
    }).href;
    if (state.currentShowDetails.published) {
      // Live show.
      previewUrl = `https://play.soundslides.com/${state.currentShowId}`;
    }

    window.open(previewUrl, "_blank");
  },
  editActiveShow({ state }) {
    // Open in same window for now.
    router.push({
      name: "edit",
      params: {
        id: state.currentShowId,
      },
    });
    // Or you can open in a new window for now.
    //var previewRoute = router.resolve({
    //  name: "preview",
    //  params:{
    //    id: state.currentShowId
    //  }
    //});
    //window.open(previewRoute.href, "_blank");
  },
  updateCurrentShow({ getters, state, commit, dispatch }) {
    commit("pendingSave");
    debouncedSaveToHistory(state, commit);
    debouncedSaveToServer(getters, state, commit, dispatch);
  },
  clearLockedSlides({ getters, dispatch }) {
    var slideArray = map(getters.editSlideArray, (s) => {
      s.unpinned = true;
      return s;
    });
    dispatch("saveSlideArray", slideArray);
  },
  clearSlidePinAtIndex({ getters, dispatch }, slideIdx) {
    var slideArray = getters.editSlideArray;
    slideArray[slideIdx].unpinned = true;
    dispatch("saveSlideArray", slideArray);
  },
  setSlidePinAtIndex({ getters, dispatch, state }, slideIdx) {
    var slideArray = getters.editSlideArray;
    slideArray[slideIdx].unpinned = false;
    // Mark preceding slides as locked if autoLockPastElasticPins enabled.
    if (state.currentShowDetails.data.displaySettings.globalTimelineAutoPin) {
      slideArray = map(slideArray, (s, idx) => {
        //console.log(idx, slideIdx);
        if (idx < slideIdx) {
          s.unpinned = false;
        }
        return s;
      });
    }
    dispatch("saveSlideArray", slideArray);
  },
  saveSlideArray({ commit, dispatch, state }, slideArray) {
    console.log("saveSlideArray");
    // Check for grouped slides here.
    var existingSlideArray = cloneDeep(
      state.currentShowDetails.data.slideArray
    );
    var newSlideArray = cloneDeep(slideArray);
    console.log(
      "saveSlideArray: isEqual",
      isEqual(existingSlideArray, newSlideArray)
    );

    commit("saveSlideArrayToShow", slideArray);
    dispatch("updateCurrentShow");
  },
  savedisplaySettings({ commit, dispatch, state }, displaySettings) {
    var slideArrayUpdateNeeded = false;
    if (
      "globalTransitionTime" in displaySettings ||
      "globalTransitionType" in displaySettings
    ) {
      slideArrayUpdateNeeded = true;
    }
    commit("savedisplaySettingsToShow", displaySettings);
    if (slideArrayUpdateNeeded) {
      // Adjust any rubberbands if needed.
      commit("saveSlideArrayToShow", state.currentShowDetails.data.slideArray);
    }
    dispatch("updateCurrentShow");
  },
  undoEdit({ state, commit, dispatch }) {
    // Go back to the last edit in history.
    console.log("undo");
    state.historyAction = true; // This prevents the undo from being logging into history.

    if (state.historyUndoLevel < state.currentShowHistory.length + 1) {
      if (state.historyUndoLevel == 0) {
        state.historyUndoLevel = 2;
      } else {
        state.historyUndoLevel++;
      }

      console.log(state.currentShowHistory);

      var undoEditDetails =
        state.currentShowHistory[
          state.currentShowHistory.length - state.historyUndoLevel
        ].showDetails;

      commit("setShowDetails", undoEditDetails);
      dispatch("updateCurrentShow");
    }
  },
  redoEdit({ state, commit, dispatch }) {
    // Go back to the last edit in history.
    console.log("redo");
    state.historyAction = true; // This prevents the undo from being logging into history.

    if (state.historyUndoLevel > 0) {
      state.historyUndoLevel--;
      var undoEditDetails =
        state.currentShowHistory[
          state.currentShowHistory.length - state.historyUndoLevel
        ].showDetails;
      commit("setShowDetails", undoEditDetails);
      dispatch("updateCurrentShow");
    }
  },
  overwriteSlideArrayWithRubberBand({ state, dispatch }) {
    var slideArray = state.currentShowDetails.data.slideArray;
    var total_duration_ms = state.currentShowDetails.data.audio.duration * 1000;
    var audioDurationOverride =
      state.currentShowDetails.data.displaySettings.audioDurationOverride || 0;
    if (audioDurationOverride > 0) {
      total_duration_ms = audioDurationOverride * 1000;
    }
    slideArray = returnAllRubberBandArray(slideArray, total_duration_ms);
    dispatch("saveSlideArray", slideArray);
  },
  overwriteSlideArrayWithRubberBandFromCurrentSlide({ state, dispatch }) {
    var currentSlideIndex = state.currentSlideIndex;
    var slideArray = state.currentShowDetails.data.slideArray;
    var total_duration_ms = state.currentShowDetails.data.audio.duration * 1000;
    var audioDurationOverride =
      state.currentShowDetails.data.displaySettings.audioDurationOverride || 0;
    if (audioDurationOverride > 0) {
      total_duration_ms = audioDurationOverride * 1000;
    }
    slideArray = returnAllRubberBandArray(
      slideArray,
      total_duration_ms,
      currentSlideIndex
    );
    dispatch("saveSlideArray", slideArray);
  },
  createSlideArrayFromLibrary({ state, commit, dispatch }, populateTimeline) {
    var showDetails = state.currentShowDetails;
    var images = showDetails.data.images;
    var duration = showDetails.data.audio.duration;
    // Two options, make a slideArray from the images, or not.
    var slideArray = [];
    if (populateTimeline) {
      // Make a default slideArray ...
      slideArray = map(images, (i, idx) => {
        return {
          file: i.filename,
          source_id: i.source_id,
          name: i.name,
          caption: "",
          timing: idx * (duration / images.length) * 1000,
        };
      });
    }

    showDetails.data.slideArray = slideArray;
    showDetails.data.assetsAvailable = true;
    commit("setShowDetails", showDetails);
    dispatch("updateCurrentShow");
  },
  createArraysFromImportedData({ state, commit, dispatch }) {
    var showDetails = state.currentShowDetails;
    var images = showDetails.data.images;
    var legacySlideArray = showDetails.data.importedXMLSlideArray;
    var slideArray = map(legacySlideArray, (i) => {
      var newFile = find(images, { name: i.file });
      return {
        file: newFile.filename,
        source_id: newFile.source_id,
        name: newFile.name,
        caption: i.caption,
        timing: i.timing,
      };
    });
    showDetails.data.slideArray = slideArray;
    // Legacy Lowerthirds to Overlays.
    var legacyOverlayArray = showDetails.data.importedXMLLowerthirdsArray;
    // All overlays need a type. Add "lowerthird" for imported types.
    legacyOverlayArray = map(legacyOverlayArray, (overlay) => {
      overlay.type = "lowerthird";
      return overlay;
    });
    showDetails.data.overlayArray = legacyOverlayArray;
    showDetails.data.assetsAvailable = true;
    commit("setShowDetails", showDetails);
    dispatch("updateCurrentShow");
  },
  login: ({ state }, login_obj) => {
    console.log("login: " + login_obj.email + login_obj.password);
    console.log(state.user);
    state.logging_in = true;
    firebase
      .auth()
      .signInWithEmailAndPassword(login_obj.email, login_obj.password)
      .then(function(firebaseUser) {
        // Success
        console.log(firebaseUser);
        if (login_obj.redirect_to_home) {
          router.push({
            name: "show-list",
          });
        }
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorCode, errorMessage);
        // ...
      });
  },
  signOut: () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        // Reload after logout.
        location.reload();
      })
      .catch((err) => alert(err.message || err));
  },
  setBowser: ({ commit }) => {
    var _bowser = Bowser.getParser(window.navigator.userAgent);
    commit("setBowser", _bowser);
  },
  updateCredentials: ({ state }) => {
    // Call for a credentials update when LibraryUpload is being mounted.
    // Nothing is returned here. The credintials are updated on the show object,
    // which comes back via Firestore binders.
    var policyUpdateEndpoint =
      "https://upload.soundslides.org/editor/policy/update/" +
      state.currentShowId +
      "/";
    //policyUpdateEndpoint = "http://127.0.0.1:5000/editor/policy/update/" + state.currentShowId + "/";
    axios.get(policyUpdateEndpoint).then(function(e) {
      console.log(e);
      console.log("updateCredentials, success");
    });
  },
};
